import { h, Fragment } from 'preact';
import clsx from 'clsx';
import { useState, useMemo } from 'preact/hooks';
import SubMenuItems from './submenu-items';
import SubMenuTabs from './submenu-tab';

const SubMenuContainer = ({
  menu,
  subMenuShowed,
  showShopAll,
  shopAllTitle,
}) => {
  const isTabsMenus = !!menu.find((m) => m.submenus.length > 0);
  const [activeTab, setActiveTab] = useState(0);
  const [activeMenu, setActiveMenu] = useState(menu[activeTab].submenus);

  const tabMenus = useMemo(
    () => (
      <>
        <SubMenuTabs
          menu={menu}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          activeMenu={activeMenu}
          setActiveMenu={setActiveMenu}
        />
      </>
    ),
    [activeMenu, activeTab],
  );

  return (
    <div
      className={clsx(
        'absolute w-full top-[100%] border-t border-black-30 left-0 transition-all overflow-hidden',
        subMenuShowed ? 'max-h-[1000px] opacity-100' : 'max-h-0 opacity-0',
      )}
    >
      <div className="pt-10 px-10 bg-neutral">
        {!isTabsMenus && (
          <div className="flex items-start justify-between gap-8 pb-10">
            <SubMenuItems menu={menu} />
          </div>
        )}
        {isTabsMenus && tabMenus}
      </div>
      {showShopAll && (
        <div className="bg-cream-grey text-center w-full pt-[18px] pb-5">
          <a href={showShopAll?.url} className="text-black cta-small uppercase underline">
            {window.TMW?.Strings?.header?.shopAll} {shopAllTitle}
          </a>
        </div>
      )}
    </div>
  );
};

export default SubMenuContainer;
